import jp from './jp.js'
import en from './en.js'
export default {
    jp,en
}
